import { loader } from "fumadocs-core/source";
// `.source/server` lo genera fumadocs-mdx en dev/build.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { docs } from "../../.source/server";

export const source = loader({
  baseUrl: "/docs",
  source: docs.toFumadocsSource(),
});
